import axios from 'axios';
import { API_URLS } from '../config/api';

class AuthService {
  constructor() {
    this.baseURL = API_URLS.LOGIN;
  }

  async login(credentials) {
    try {
      const response = await axios.post(this.baseURL, credentials);
      
      if (response.data.success) {
        // Store tokens and user data in localStorage
        localStorage.setItem('accessToken', response.data.tokens.accessToken);
        localStorage.setItem('refreshToken', response.data.tokens.refreshToken);
        localStorage.setItem('user', JSON.stringify(response.data.data));
        localStorage.setItem('tokenExpiry', new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString()); // 2 hours from now
      }
      
      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  }

  logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    localStorage.removeItem('tokenExpiry');
  }

  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }

  getAccessToken() {
    return localStorage.getItem('accessToken');
  }

  isAuthenticated() {
    const token = this.getAccessToken();
    const expiry = localStorage.getItem('tokenExpiry');
    
    if (!token || !expiry) {
      return false;
    }
    
    return new Date(expiry) > new Date();
  }

  getAuthHeaders() {
    const token = this.getAccessToken();
    return token ? { Authorization: `${token}` } : {};
  }

  async changePassword(currentPassword, newPassword) {
    try {
      // Get the current user to extract vendor ID
      const user = this.getCurrentUser();
      if (!user || !user.id) {
        throw new Error('User not found. Please login again.');
      }

      const response = await axios.put(
        `${API_URLS.CHANGE_PASSWORD}/${user.id}`,
        {
          currentPassword,
          newPassword
        },
        {
          headers: this.getAuthHeaders()
        }
      );
      
      if (response.data.success) {
        return {
          success: true,
          message: response.data.message || 'Password changed successfully'
        };
      } else {
        throw new Error(response.data.message || 'Failed to change password');
      }
    } catch (error) {
      console.error('Change password error:', error);
      throw new Error(
        error.response?.data?.message || 
        'Failed to change password. Please try again.'
      );
    }
  }
}

export const authService = new AuthService();
